import React from 'react';
import { TableRow } from '@material-ui/core';
import { StyledTableCell } from '../../../../containers/MainContentContainer/CommonTableComponent/CommonTable';
import PlaceholderImage from '../../../../assets/placeholderImg.png';
import useTranslate from '../../../../hooks/useTranslate';
import { useState } from 'react';
import { useCallback } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import { FetchCategoryIcon } from '../../../../helpers/categoryIcons';
import { DateTime } from 'luxon';
import { Tooltip } from '@mui/material';

const ActiveCompaniesTable = ({
  row,
  index,
  activeRow,
  setActiveRow,
  setCaseDetails,
}) => {
  const t = useTranslate();
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const images = [...row?.images];
  const filteredImages = images?.map((image) => image.path);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <TableRow
      row={row}
      key={index}
      onClick={() => {
        setCaseDetails(row);
        setActiveRow(index);
      }}
    >
      <StyledTableCell>
        <div className="flex w-72 gap-3">
          <div className="min-photo rounded">
            <img
              src={
                row?.user?.profile_image === null
                  ? PlaceholderImage
                  : row?.user?.profile_image
              }
              onError={({ currentTarget }) => {
                currentTarget.src = PlaceholderImage;
              }}
              alt="user"
              className="w-full h-full rounded-full object-cover"
            />
          </div>
          <div className=" truncate w-72">
            <p className="font-semibold text-base leading-6 font-color ">
              {row?.user?.name} {row?.user?.last_name}
            </p>
            <span className="font-color">
              {row?.user?.post_code} {row?.user?.street}
            </span>
          </div>
        </div>
      </StyledTableCell>
      <StyledTableCell>
        <div className="flex w-44 gap-3 items-center">
          <FetchCategoryIcon
            name={row?.category?.icon}
            strokeColor="strokePurple"
          />
          <div className="">
            <div className="">
              <p className="font-semibold text-base leading-6 font-color">
                {row?.category?.parent?.name}
              </p>
              <span className="font-color">{row?.category?.name}</span>
            </div>
          </div>
        </div>
      </StyledTableCell>
      <StyledTableCell>
        <Tooltip title={<p className="text-base">{row?.description}</p>}>
          <div className="flex flex-wrap w-48">
            <span className="line-clamp-3">{row?.description}</span>
          </div>
        </Tooltip>
      </StyledTableCell>
      <StyledTableCell>
        <Tooltip title={<p className="text-base">{row?.expert_opinion}</p>}>
          <div className="flex flex-wrap w-48">
            <span className="line-clamp-3">{row?.expert_opinion}</span>
          </div>
        </Tooltip>
      </StyledTableCell>
      <StyledTableCell>
        <div className="flex items-center">
          {filteredImages.slice(0, 2).map((src, index) => (
            <img
              src={src}
              onClick={() => openImageViewer(index)}
              className="max-w-70 h-14"
              key={index}
              style={{ margin: '2px' }}
              alt=""
            />
          ))}

          {isViewerOpen && (
            <ImageViewer
              backgroundStyle={{
                backgroundColor: '#7209b760',
                zIndex: '99',
                transition: '0.3s ease-out',
              }}
              src={filteredImages}
              currentIndex={currentImage}
              disableScroll={false}
              closeOnClickOutside={true}
              onClose={closeImageViewer}
            />
          )}
          <p className="text-indigo-800 font-medium text-base leading-6">
            {filteredImages?.length > 2 ? `+${filteredImages?.length - 2}` : ''}
          </p>
        </div>
      </StyledTableCell>
      <StyledTableCell>
        <div className="font-medium text-base">
          {DateTime.fromISO(row?.time_slots?.time_from, {
            zone: 'Europe/Stockholm',
          }).toFormat('HH:mm')}
        </div>
        <div>{row?.time_slots?.date_from}</div>
      </StyledTableCell>
    </TableRow>
  );
};

export default ActiveCompaniesTable;
